import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RbacService } from '../../core/rbac/rbac.service';
import { AuthService } from '../../core/services/auth.service';

/**
 * Structural directive: show element only if user has at least one of the given permissions.
 * Usage: *rbacCan="'patient.edit'" or *rbacCan="['patient.edit', 'patient.register']"
 * Use for buttons, forms, tabs, and widgets to enforce RBAC without scattered inline checks.
 */
@Directive({
  selector: '[rbacCan]',
  standalone: true,
})
export class RbacCanDirective implements OnInit, OnDestroy {
  private sub?: Subscription;
  private hasView = false;
  private currentPerms: string[] = [];

  @Input() set rbacCan(permission: string | string[]) {
    this.currentPerms = Array.isArray(permission) ? permission : [permission];
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<unknown>,
    private vcr: ViewContainerRef,
    private rbac: RbacService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.sub = this.auth.currentUser$.subscribe(() => this.updateView());
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private updateView(): void {
    const allowed =
      this.currentPerms.length === 0 || this.rbac.canAny(this.currentPerms as any);
    if (allowed && !this.hasView) {
      this.vcr.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.vcr.clear();
      this.hasView = false;
    }
  }
}
